import React, { Component } from 'react';
import { observer, PropTypes as MobxPropTypes } from 'mobx-react';

import RoundPanel from './RoundPanel';
import RoundInfo from './RoundInfo';

@observer
class RoundSection extends Component {
  static propTypes = {
    ui: MobxPropTypes.observableObject,
    store: MobxPropTypes.observableObject,
  };

  handleSaveRound = (roundDefinition) => {
    const {
      ui,
      store,
      store: { mode },
    } = this.props;
    switch (mode) {
      case 'new':
        store.start(roundDefinition);
        break;
      case 'edit':
        store.edit(roundDefinition);
        break;
      default:
        break;
    }
    ui.closePanel();
  };

  render() {
    const {
      ui,
      store,
      store: { definition: round, mode },
    } = this.props;
    if (!round.isEnabled) {
      return <span />;
    }

    return (
      <RoundPanel
        isOpen={true}
        mode={mode}
        round={round}
        offerData={store.root.saleEdit.offerData}
        canChangeType={store.canChangeType}
        onSave={this.handleSaveRound}
        onClose={() => ui.closePanel()}
      />
    );
  }
}

export { RoundSection, RoundInfo };



// WEBPACK FOOTER //
// ./src/app/containers/Sale/RoundSection/index.jsx